import React, {useState} from 'react';
import styles from './Header.module.css';
import logo from '../../Compenents/assets/6.png';

const Header = ()=>{
    const[active, setactive] = useState(1);
    function hume(i:number){
        setactive(i)
        
    }
    return(
        <>
        <div className={styles.header}>
            <img src={logo} className={styles.logo} alt="" />
            <ul>
                <li><a href="#home" onClick={() =>hume(1)} className={active===1? styles.active : ''}>Accueil</a></li>
                <li><a href="#about" onClick={() =>hume(2)}  className={active===2? styles.active : ''}>A propos</a></li>
                <li><a href="#service" onClick={() =>hume(3)}  className={active===3? styles.active : ''}>Services</a></li>
                <li><a href="#contact" onClick={() =>hume(4)}  className={active===4? styles.active : ''}>Contact</a></li>
            </ul>
        </div>
        
        </>

    );
}

export default Header;